import spriteAlphaDataCache from './SpriteAlphaDataCache';
import { utils } from '../../utils';

/**
 * Pre-warm the sprite alpha data cache with commonly used sprites
 * Call this at game initialization to avoid frame stuttering during gameplay
 */
export const preWarmSpriteAlphaCache = async () =>
{
  const clickableSpritesWithAlpha =
    [
      // Meeple outlines for placement options
      utils.getAssetPath( './meeples/Meeple - Outline - Standing.png' ),
      utils.getAssetPath( './meeples/Meeple - Outline - Farmer.png' ),
    ];

  await spriteAlphaDataCache.preWarmCache( clickableSpritesWithAlpha );

  // Log cache statistics only in development builds
  if( process.env.NODE_ENV === 'development' )
  {
    const stats = spriteAlphaDataCache.getStats();
    // console.log( 'Sprite Alpha Cache Stats:', stats );
  }
};

/**
 * Get cache statistics for debugging/monitoring
 */
export const getSpriteAlphaCacheStats = () =>
{
  return spriteAlphaDataCache.getStats();
};

/**
 * Clear the sprite alpha cache (useful for memory management)
 */
export const clearSpriteAlphaCache = () =>
{
  spriteAlphaDataCache.clearCache();
};
